import React, { useState, useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useTheme } from '../../context/ThemeContext';
import axios from 'axios';
import { base_url } from '../../context/Authcontext';
import toast from 'react-hot-toast';

const GameButtons = ({ showV, handleCloseV, onButtonsChange }) => {
    const [buttons, setButtons] = useState([]);
    const { themeColors } = useTheme();
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

    useEffect(() => {
        const fetchButtons = async () => {
            try {
                const res = await axios.get(`${base_url}/api/webapi/game-buttons`);
                onButtonsChange && onButtonsChange(res.data);
                setButtons(res.data);
            } catch (err) {
                console.error("Error fetching buttons", err);
            }
        };
        fetchButtons();
    }, []);



    const handleChange = (index, key, newValue) => {
        const updated = [...buttons];
        updated[index][key] = newValue;
        setButtons(updated);
        onButtonsChange && onButtonsChange(updated);
    };

    const handleUpdate = async () => {
        try {
            await axios.post(`${base_url}/api/webapi/game-buttons`, { buttons });
            toast.success("Updated Successfully!");

            const res = await axios.get(`${base_url}/api/webapi/game-buttons`);
            setButtons(res.data);
            onButtonsChange && onButtonsChange(res.data);
        } catch (err) {
            console.error("Error updating buttons", err);
        }
    };



    return (
        <>
            <style>
                {`
                   .offcanvas-header{
                    background-color: var(--bg-primary)
                   }
                    .offcanvas-centered-x {
                        left: 50% !important;
                        transform: translateX(-50%) !important;
                    } 
                    }
                `}
            </style>
            <Offcanvas show={showV} onHide={handleCloseV} placement="top"
                className="offcanvas-centered-x"
                style={{
                    height: "100vh",
                    background: "transparent",
                    width: isLargeScreen ? "37%" : "100%",
                }}>
                <Offcanvas.Header closeButton style={{ backgroundColor: themeColors['--bg-primary'], padding: "10px", color: themeColors['--text-primary'] }}>
                    <Offcanvas.Title className="my-0">Set Button Value</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="p-0 bg-light">
                    <div className="container mt-2" style={{ maxWidth: '500px' }}>
                        <button className="mb-0 py-1 px-3 text-white text-center border-none" style={{ backgroundColor: themeColors['--bg-secondary'] }}>Game Buttons</button>
                        <div className="row font-weight-bold mb-2">
                            <div className="col"><h5>Price Label:</h5></div>
                            <div className="col"><h5>Price Value:</h5></div>
                        </div>

                        {buttons.map((btn, index) => (
                            <div className="row mb-2" key={btn.id || index}>
                                <div className="col pe-0">
                                    <input
                                        type="text"
                                        className="w-100 p-2"
                                        style={{ border: "1px solid var(--input-border)" }}
                                        value={btn.label}
                                        onChange={(e) => handleChange(index, 'label', e.target.value)}
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        type="number"
                                        className="w-100 p-2"
                                        style={{ border: "1px solid var(--input-border)" }}
                                        value={btn.value}
                                        onChange={(e) => handleChange(index, 'value', e.target.value)}
                                    />
                                </div>
                            </div>
                        ))}

                        <button className="btn text-light w-50 mt-3"
                            onClick={handleUpdate}
                            style={{ backgroundColor: themeColors['--bg-primary'] }}>
                            Update
                        </button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default GameButtons;
